import React from 'react';
import { renderValue } from '../RenderValue';

export default function ValuesOnly({ values }: { values: any[] }) {
  const firstValue = values[0];
  const remainingValues = values.slice(1);

  return (
    <>
      {renderValue(firstValue, true,null, values.length === 1)}

      {remainingValues.length > 0 && (
        <tr>
          <td className="price" style={{ backgroundColor: '#006991', color: 'white', textAlign: 'center' }} colSpan={2}>
            PREÇOS POSSÍVEIS NA TABELA SOMOS
          </td>
        </tr>
      )}

      {remainingValues.map((item, index) => (
        <React.Fragment key={index}>{renderValue(item, false,undefined,values)}</React.Fragment>
      ))}
    </>
  );
}
